const ALL_PROJECTS = [
    {
        id: 1,
        title: "HealthTrack Pro",
        slug: "healthtrack-pro",
        category: "Mobile App",
        key: "mobile",
        description: "Comprehensive health monitoring app with real-time vitals tracking, appointment scheduling, and telemedicine integration for 50,000+ active users.",
        tags: ["React Native", "Node.js", "MongoDB"],
        gradient: "linear-gradient(135deg,#4A7CC7 0%,#6C5CE7 100%)",
        shapes: "M-20 40 Q40 -10 100 30 T200 20",
        featured: true,
        href: null,
        image: "",
        published: false,
    },
    {
        id: 2,
        title: "LuxeShop E-Commerce",
        slug: "luxeshop-ecommerce",
        category: "E-Commerce",
        key: "ecommerce",
        description: "High-end fashion marketplace with AR try-on, personalised recommendations, and seamless multi-currency checkout.",
        tags: ["Next.js", "Stripe", "PostgreSQL"],
        gradient: "linear-gradient(135deg,#E0274A 0%,#FF6B6B 100%)",
        shapes: "M0 50 Q50 0 100 50 T200 50",
        featured: false,
        href: null,
        image: "",
        published: false,
    },
    {
        id: 3,
        title: "FinDash Analytics",
        slug: "findash-analytics",
        category: "Web Development",
        key: "web",
        description: "Real-time financial analytics dashboard processing 2M+ daily transactions with interactive charts, custom report builder, and role-based access control.",
        tags: ["React", "D3.js", "Python", "Redis"],
        gradient: "linear-gradient(135deg,#00B894 0%,#00CEC9 100%)",
        shapes: "M0 60 L40 20 L80 50 L120 10 L160 40 L200 20",
        featured: true,
        href: null,
        image: "",
        published: false,
    },
    {
        id: 4,
        title: "FoodFleet Delivery",
        slug: "foodfleet-delivery",
        category: "Mobile App",
        key: "mobile",
        description: "On-demand food delivery platform with live order tracking, AI-powered ETA predictions, and driver gamification for 200+ restaurant partners.",
        tags: ["Flutter", "Firebase", "Google Maps"],
        gradient: "linear-gradient(135deg,#FDCB6E 0%,#E17055 100%)",
        shapes: "M0 30 C40 0,80 60,120 30 S160 0,200 30",
        featured: false,
        href: null,
        image: "",
        published: false,
    },
    {
        id: 5,
        title: "UnifyERP",
        slug: "unify-erp",
        category: "Custom Software",
        key: "enterprise",
        description: "Comprehensive enterprise ERP unifying finance, inventory, purchasing, and HR on a single platform — eliminating data silos and streamlining operations for mid-to-large enterprises.",
        tags: ["React", "Node.js", "PostgreSQL", "Redis"],
        gradient: "linear-gradient(135deg,#2D3436 0%,#636E72 100%)",
        shapes: "M20 0 L100 80 L180 0",
        featured: true,
        href: null,
        image: "",
        published: false,
    },
    {
        id: 6,
        title: "EduSphere LMS",
        slug: "edusphere-lms",
        category: "Web Development",
        key: "web",
        description: "Feature-rich learning management system with live virtual classrooms, adaptive quizzes, progress analytics, and gamified course completion for 100K+ learners.",
        tags: ["Next.js", "WebRTC", "AWS", "MySQL"],
        gradient: "linear-gradient(135deg,#A29BFE 0%,#6C5CE7 100%)",
        shapes: "M0 20 Q100 -20 200 20",
        featured: true,
        href: null,
        image: "",
        published: false,
    },
    {
        id: 7,
        title: "HealthCore",
        slug: "healthcore",
        category: "Custom Software",
        key: "enterprise",
        description: "HIPAA-compliant healthcare platform managing patient records, appointment scheduling, and clinical workflows for multi-specialty clinics with real-time data sync and full audit trails.",
        tags: ["Angular", "Python", "FHIR", "PostgreSQL"],
        gradient: "linear-gradient(135deg,#00B894 0%,#00CEC9 100%)",
        shapes: "M0 40 Q50 10 100 40 T200 40",
        featured: false,
        href: null,
        image: "",
        published: false,
    },
    {
        id: 8,
        title: "TravelMate App",
        slug: "travelmate-app",
        category: "Mobile App",
        key: "mobile",
        description: "All-in-one travel companion with itinerary planning, offline maps, currency converter, and AI travel assistant available in 18 languages.",
        tags: ["React Native", "GraphQL", "OpenAI"],
        gradient: "linear-gradient(135deg,#00B894 0%,#55EFC4 100%)",
        shapes: "M0 50 Q100 0 200 50",
        featured: false,
        href: null,
        image: "",
        published: false,
    },
    {
        id: 9,
        title: "MedSupply Chain",
        slug: "medsupply-chain",
        category: "E-Commerce",
        key: "ecommerce",
        description: "B2B medical supply marketplace with real-time inventory sync, bulk ordering, FDA compliance tracking, and automated procurement workflows.",
        tags: ["Next.js", "GraphQL", "PostgreSQL"],
        gradient: "linear-gradient(135deg,#E0274A 0%,#A29BFE 100%)",
        shapes: "M0 0 Q100 80 200 0",
        featured: false,
        href: null,
        image: "",
        published: false,
    },
    {
        id: 10,
        title: "BrandForge Studio",
        slug: "brandforge-studio",
        category: "UI/UX Design",
        key: "design",
        description: "Complete brand identity platform built from Figma to production-ready React, serving a global creative agency with 40+ component library.",
        tags: ["Figma", "React", "Storybook", "Tailwind"],
        gradient: "linear-gradient(135deg,#FD79A8 0%,#E84393 100%)",
        shapes: "M10 70 C40 30,80 10,110 40 S160 70,200 50",
        featured: false,
        href: null,
        image: "",
        published: false,
    },
    {
        id: 11,
        title: "CloudOps Dashboard",
        slug: "cloudops-dashboard",
        category: "Web Development",
        key: "web",
        description: "Multi-cloud infrastructure management console with cost analytics, resource auto-scaling triggers, and incident response automation for enterprise DevOps teams.",
        tags: ["React", "AWS SDK", "Terraform", "Go"],
        gradient: "linear-gradient(135deg,#2D3436 0%,#0984E3 100%)",
        shapes: "M0 30 L50 60 L100 20 L150 50 L200 30",
        featured: false,
        href: null,
        image: "",
        published: false,
    },
    {
        id: 12,
        title: "RiskPulse Analytics",
        slug: "riskpulse-analytics",
        category: "Custom Software",
        key: "enterprise",
        description: "Real-time financial risk analytics platform ingesting multi-source market data, generating dynamic risk scores, and delivering actionable insights through configurable visual dashboards.",
        tags: ["React", "D3.js", "Apache Kafka", "Python"],
        gradient: "linear-gradient(135deg,#FDCB6E 0%,#6C5CE7 100%)",
        shapes: "M0 60 L40 20 L80 50 L120 10 L160 40 L200 20",
        featured: false,
        href: null,
        image: "",
        published: false,
    },
    {
        id: 13,
        title: "ProdTrack IoT",
        slug: "prodtrack-iot",
        category: "Custom Software",
        key: "enterprise",
        description: "IoT-driven manufacturing monitoring system capturing real-time sensor data from production lines, detecting anomalies, and optimising throughput with predictive maintenance alerts.",
        tags: ["React", "MQTT", "Node.js", "InfluxDB"],
        gradient: "linear-gradient(135deg,#E17055 0%,#FDCB6E 100%)",
        shapes: "M0 40 Q40 10 80 35 T160 30 L200 40",
        featured: false,
        href: null,
        image: "",
        published: false,
    },
    {
        id: 14,
        title: "ChainVision",
        slug: "chainvision",
        category: "Custom Software",
        key: "enterprise",
        description: "End-to-end supply chain visibility platform providing real-time tracking of inventory levels, supplier performance, and logistics movements across the entire distribution network.",
        tags: ["Vue.js", "Node.js", "MongoDB", "Kafka"],
        gradient: "linear-gradient(135deg,#0984E3 0%,#00CEC9 100%)",
        shapes: "M0 30 C40 0,80 60,120 30 S160 0,200 30",
        featured: false,
        href: null,
        image: "",
        published: false,
    },
    {
        id: 15,
        title: "Ok Safety",
        slug: "ok-safety",
        category: "Custom Software",
        key: "enterprise",
        description: "Enterprise safety management platform streamlining workplace safety protocols, incident reporting, and compliance tracking across 12 industrial sites — cutting incidents by 40%.",
        tags: ["React", "Node.js", "MongoDB"],
        gradient: "linear-gradient(135deg,#E0274A 0%,#2D3436 100%)",
        shapes: "M0 40 Q50 10 100 40 T200 40",
        featured: true,
        href: "/portfolio/ok-safety",
        image: "/images/portfolio/ok-safety/ok-safety-dashboard.webp",
        logo: "/images/portfolio/ok-safety/OK-Saftey-logo.webp",
        published: true,
    },
];

export const PROJECTS = ALL_PROJECTS.filter(p => p.published);

export const FILTERS = [
    { key: "all", label: "All Projects" },
    { key: "web", label: "Web Development" },
    { key: "mobile", label: "Mobile App" },
    { key: "ecommerce", label: "E-Commerce" },
    { key: "software", label: "Custom Software" },
    { key: "design", label: "UI/UX Design" },
];

export const STATS = [
    { stat: "500+", label: "Successful Projects\nDelivered" },
    { stat: "98%", label: "Client Satisfaction\nRate" },
    { stat: "12+", label: "Global Delivery\nCenters" },
];
